"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("./colors"));

var _util = require("./util");

var _space = _interopRequireDefault(require("./space"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  Button: {
    lineHeight: '16px',
    cursor: 'pointer',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: 4,
    fontWeight: 'bold',
    transition: "background-color 250ms ".concat(_util.transition, ", border-color 250ms ").concat(_util.transition),
    '&:hover': {
      textDecoration: 'none'
    },
    '&:focus': {
      outline: 'none',
      textDecoration: 'none'
    },
    '&:active': {
      // boxShadow: shadows.large,
      transition: 'none',
      textDecoration: 'none'
    },
    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'none',
      opacity: 0.5
    }
  },
  buttons: {
    primary: {
      color: 'white',
      backgroundColor: _colors["default"].teal[500],
      borderColor: _colors["default"].teal[500],
      '&:focus': {
        color: 'white',
        textDecoration: 'none'
      },
      '&:hover': {
        backgroundColor: _colors["default"].teal[800],
        borderColor: _colors["default"].teal[800],
        color: 'white'
      },
      '&:active': {
        backgroundColor: _colors["default"].teal[400],
        borderColor: _colors["default"].teal[400],
        color: 'white'
      }
    },
    secondary: {
      color: _colors["default"].teal[500],
      backgroundColor: 'transparent',
      borderColor: _colors["default"].teal[500],
      '&:hover': {
        backgroundColor: _colors["default"].teal[100],
        borderColor: _colors["default"].teal[800],
        color: _colors["default"].teal[800]
      },
      '&:focus': {
        color: _colors["default"].teal[500],
        textDecoration: 'none'
      },
      '&:active': {
        backgroundColor: _colors["default"].teal[100],
        borderColor: _colors["default"].teal[500],
        color: _colors["default"].teal[500]
      }
    },
    "default": {
      color: _colors["default"].teal[500],
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&:hover': {
        backgroundColor: _colors["default"].teal[100],
        borderColor: _colors["default"].teal[100],
        color: _colors["default"].teal[800]
      },
      '&:active': {
        backgroundColor: _colors["default"].teal[100],
        borderColor: _colors["default"].teal[100],
        color: _colors["default"].teal[500]
      }
    },
    danger: {
      color: 'white',
      backgroundColor: _colors["default"].red[500],
      borderColor: _colors["default"].red[500],
      '&:hover': {
        backgroundColor: _colors["default"].red[800],
        borderColor: _colors["default"].red[800]
      },
      '&:active': {
        backgroundColor: _colors["default"].red[400],
        borderColor: _colors["default"].red[400]
      }
    },
    'secondary-danger': {
      color: _colors["default"].red[500],
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&:hover': {
        backgroundColor: _colors["default"].red[100],
        borderColor: _colors["default"].red[100],
        color: _colors["default"].red[800]
      },
      '&:active': {
        backgroundColor: _colors["default"].red[100],
        borderColor: _colors["default"].red[100],
        color: _colors["default"].red[500]
      }
    },
    neutral: {
      color: _colors["default"].neutral[500],
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      '&:hover': {
        backgroundColor: _colors["default"].neutral[100],
        borderColor: _colors["default"].neutral[100],
        color: _colors["default"].neutral[800]
      },
      '&:active': {
        backgroundColor: _colors["default"].neutral[100],
        borderColor: _colors["default"].neutral[100],
        color: _colors["default"].neutral[500]
      }
    }
  },
  buttonSizes: {
    medium: {
      lineHeight: '16px',
      fontSize: '16px',
      paddingTop: _space["default"][2],
      paddingBottom: _space["default"][2],
      paddingRight: _space["default"][3],
      paddingLeft: _space["default"][3]
    },
    small: {
      lineHeight: '12px',
      fontSize: '12px',
      paddingTop: _space["default"][1],
      paddingBottom: _space["default"][1],
      paddingLeft: _space["default"][3],
      paddingRight: _space["default"][3]
    },
    large: {
      lineHeight: '18px',
      fontSize: '18px',
      paddingTop: _space["default"][3],
      paddingBottom: _space["default"][3],
      paddingLeft: _space["default"][3],
      paddingRight: _space["default"][3]
    }
  }
};
exports["default"] = _default;